import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';
import { setCurrentImpersonation } from '../api/impersonationRef';

interface ImpersonationState {
  impersonating: string | null;
  setImpersonating: (email: string | null) => void;
}

const ImpersonationContext = createContext<ImpersonationState>({
  impersonating: null,
  setImpersonating: () => {},
});

export function ImpersonationProvider({ children }: { children: ReactNode }) {
  const [impersonating, setImpersonating] = useState<string | null>(null);

  // Keep the module-level ref in sync so the HTTP service can read it
  useEffect(() => {
    setCurrentImpersonation(impersonating);
  }, [impersonating]);

  return (
    <ImpersonationContext.Provider value={{ impersonating, setImpersonating }}>
      {children}
    </ImpersonationContext.Provider>
  );
}

export const useImpersonation = () => useContext(ImpersonationContext);
